/*
 *
 * DimensionByDivision actions
 *
 */

import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
  GRAPHIC_BARS_WATCHER,
  GRAPHIC_BARS_SUCCESS,
  GRAPHIC_BARS_FAILED,
  GET_HISTORY_WATCHER,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_BY_DIVISION_SUCCESS,
  GET_HISTORY_BY_DIVISION_WATCHER,
  GET_AMBASSADORS_WATCHER,
  GET_AMBASSADORS_SUCCESS,
  GET_AMBASSADORS_FAILED,
  GET_ONLY_DIMENSIONS_WATCHER,
  GET_ONLY_DIMENSIONS_SUCCESS,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_QUESTIONS_WATCHER,
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_FAILED,
} from "./constants"

export function getQuestionsWatcher(payload) {
  return {
    type: GET_QUESTIONS_WATCHER,
    payload,
  }
}

export function getQuestionsSuccess(payload) {
  return {
    type: GET_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getQuestionsFailed() {
  return { type: GET_QUESTIONS_FAILED }
}

export function getOnlyDimensionsWatcher(payload) {
  return {
    type: GET_ONLY_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getOnlyDimensionsSuccess(payload) {
  return {
    type: GET_ONLY_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getAmbassadorsWatcher(payload) {
  return {
    type: GET_AMBASSADORS_WATCHER,
    payload,
  }
}

export function getAmbassadorsSuccess(payload) {
  return {
    type: GET_AMBASSADORS_SUCCESS,
    payload,
  }
}

export function getAmbassadorsFailed() {
  return { type: GET_AMBASSADORS_FAILED }
}

export function graphicBarsWatcher(payload) {
  return {
    type: GRAPHIC_BARS_WATCHER,
    payload,
  }
}

export function graphicBarsSuccess(payload) {
  return {
    type: GRAPHIC_BARS_SUCCESS,
    payload,
  }
}

export function graphicBarsFailed() {
  return { type: GRAPHIC_BARS_FAILED }
}

export function getDivisionsWatcher(payload) {
  return {
    type: GET_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed() {
  return { type: GET_DIVISIONS_FAILED }
}

export function getDimensionsWatcher(payload) {
  return {
    type: GET_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getDimensionsSuccess(payload) {
  return {
    type: GET_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getDimensionsFailed() {
  return { type: GET_DIMENSIONS_FAILED }
}

export function getHistoryByDivisionWatcher(payload) {
  return {
    type: GET_HISTORY_BY_DIVISION_WATCHER,
    payload,
  }
}

export function getHistoryByDivisionSuccess(payload) {
  return {
    type: GET_HISTORY_BY_DIVISION_SUCCESS,
    payload,
  }
}

export function getHistoryByDivisionFailed(payload) {
  return { type: GET_HISTORY_SUCCESS }
}

export function getDimensionsMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getDimensionsMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}
